import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Loader from '../../components/Loader';
import { XMarkIcon, ArrowPathIcon, ChevronLeftIcon, ChevronRightIcon, ShareIcon } from '@heroicons/react/24/outline';
import useToast from '../../components/Toast/index';
import useNavigation from '../../hook/useNavigation';

const Tracking = () => {
  const navigate = useNavigation();
	const location = useLocation();
	const { showToast } = useToast();
	const { trackingUrl, backPath } = location.state;

	const [isLoading, setIsLoading] = useState(false);

	const handleShare = (text = '') => {
		if (navigator.share) {
			navigator
				.share({
					title: 'Lacak Pesanan Anda',
					text: 'Lacak pesananmu secara langsung di sini:',
					url: text,
				})
				.then(() => showToast('info', 'URL berhasil dibagikan'))
				.catch((error) => {
					console.error('Gagal membagikan:', error);
					showToast('error', 'Gagal membagikan URL');
				});
		} else {
			navigator.clipboard
				.writeText(text)
				.then(() => {
					showToast('info', 'URL berhasil disalin ke papan klip');
				})
				.catch((err) => {
					console.error('Gagal menyalin: ', err);
					showToast('error', 'Gagal menyalin URL');
				});
		}
	};

	const handleReload = () => {
		setIsLoading(true);
		setTimeout(() => {
			setIsLoading(false);
		}, 500);
	};

	return (
		<>
			{isLoading && <Loader overlay />}
			<div className='h-screen w-full flex justify-center items-center'>
				<div className='relative h-screen w-full max-w-lg'>
					<div className={`absolute mt-5 w-full max-w-lg bg-white border-b-1 border-solid border-gray-200 pb-1`}>
						<div className='flex flex-row justify-between mx-4'>
							<div className='flex justify-center items-center cursor-pointer'>
								<XMarkIcon className='h-8 w-8 text-gray-900 bg-white rounded-full p-1.5' strokeWidth={3} onClick={() => navigate.push(backPath ? backPath : '/')} />
								<div className='text-gray-900 font-bold text-base pl-1'>Lacak secara Real-Time</div>
							</div>
							<div className='flex gap-4 items-center'>
								<ShareIcon className='h-5 w-5 font-bold text-gray-900' strokeWidth={3} onClick={() => handleShare(trackingUrl)} />
								<ArrowPathIcon className='h-6 w-6 text-gray-900' strokeWidth={2} onClick={handleReload} />
								<ChevronLeftIcon className='h-5 w-5 text-gray-400' strokeWidth={3} />
								<ChevronRightIcon className='h-5 w-5 text-gray-400' strokeWidth={3} />
							</div>
						</div>
					</div>
					<div className='pt-16 h-full'>{!isLoading && <iframe src={trackingUrl} title='description' className='w-full h-full'></iframe>}</div>
				</div>
			</div>
		</>
	);
};

export default Tracking;
